import { ChangeDetectorRef, Component, EventEmitter, HostListener, Inject, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges, TemplateRef, ViewChild } from "@angular/core";
import { Version } from "../webhook-edit.component";
import { Answer, IAConversation, IAConverse, IAServices } from "../../webhook-services/IAServices";
import { first, map, Observable } from "rxjs";
import { NZ_MODAL_DATA, NzModalService } from "ng-zorro-antd/modal";
import { NZ_DRAWER_DATA, NzDrawerRef } from "ng-zorro-antd/drawer";
import { GlobalErrorHandler } from "src/app/services/GloabalErrorHandler.services";
import { UserAuthenticationServices } from "src/app/services/user-authentication.services";
import { LanguageServices } from "src/app/services/LanguageServices";
import { DomSanitizer } from "@angular/platform-browser";


@Component({
  selector: 'ia-json-viewer-modal',
  template: `
    <json-viewer
      [json]="data" 
      [readOnly]="true">
    </json-viewer>
  `,
  standalone: false
})
export class IAJsonViewerModalComponent {
  @Input() data: any;
  constructor(@Inject(NZ_MODAL_DATA) public nzData) {
        this.data = this.nzData;
  }
}


@Component({
    selector: 'webhook-ia-assistant',
    templateUrl: './webhook-ia-assistant.component.html',
    styleUrl: './webhook-ia-assistant.component.scss',
    standalone: false
})



export class WebhookAIAssistantComponent implements OnInit {
    sub1: any;
    sub2: any;
    initLoading:boolean = false;
    flow:object = {};
    version:Version = null;
    uas: UserAuthenticationServices;
    isCtrlPressed: boolean;


    constructor(
            private cd: ChangeDetectorRef, 
            public iaService: IAServices,
            private ts:LanguageServices,
            private drawerRef: NzDrawerRef<any>,
            private modalService:NzModalService,
            public sanitizer:DomSanitizer,
            private renderer: Renderer2,
            @Inject(NZ_DRAWER_DATA) private nzData,
        ) { 
        this.converse = iaService.converse$;

        if ( this.nzData.sessionId != null ){
            this.sessionId = this.nzData.sessionId;
        }

        if ( this.nzData.nodes!= null && this.nzData.nodes.length>0  ){

            this.flow = {
                steps: this.nzData.nodes,
                connectors:this.nzData.connections
            };
        }

        if ( this.nzData.version != null ){
            this.version = this.nzData.version;
        }

        if ( this.nzData.user != null ){
            this.uas = this.nzData.user;
        }

        if ( this.nzData.idconf != null ){
            this.idconf = this.nzData.idconf;
        }
    }

    userPrompt = '';
    converse: Observable<IAConversation[]>;
    loading = false;
    lastQuestion = '';
    agent:string = 'openai.temapi.ai.flow.agent';
    sessionId:string = null;
    idconf:number = null;

    ngOnDestroy(): void {   
        if ( this.sub1 ) {
            this.sub1.unsubscribe();
        }
        if ( this.sub2 ) {
            this.sub2.unsubscribe();
        }
    }

    enviarPrompt() {
        this.loading = true;
        
        //this.iaService.updateConverse( this.sessionId, this.agent, { text: this.userPrompt, role: 'user' });
        this.converseWithAI(this.userPrompt);
        this.userPrompt = '';
        
        

        setTimeout(()=>this.scrollToBottom(),100);
        
        /*setTimeout(() => {
                fetch('/assets/file.txt')
                .then(res => res.text())
                .then(text => {
                    let json = this.reponseTratamento(text,"123123213213").json;
                    let cleaned = this.reponseTratamento(text,"123123213213").cleaned;
                    let ob:IAConverse = { converseId:"123123213213", text: cleaned, role: 'assistant' , action: json};
                    this.iaService.updateConverse(this.sessionId, this.agent, ob);
                    this.loading = false;
                    this.cd.detectChanges();
                    this.scrollToBottom();

                });

            }, 2000);*/

    }

    feedback(index: number, positivo: boolean) {
        this.sub2 = this.converse.subscribe((converseList:IAConversation[])=> {
            converseList.filter(d=>d.sessionId == this.sessionId && d.agent == this.agent).forEach(conv=>{
                const resposta = conv.messages[index];
                resposta.feedback = positivo ? 'up' : 'down';       
            });
            
        });
    }

   get messages(): Observable<IAConverse[]> {
    return this.converse.pipe(
        map((converseList: IAConversation[]) => {
            const conv = converseList.find(d => d.sessionId === this.sessionId && d.agent === this.agent);
            return conv?.messages ?? [];
            })
        );
    }



    ngOnInit(): void {
        this.isSessionInitialized();
        setTimeout(()=>this.scrollToBottom(),100);
    }

    isSessionInitialized() {
        this.converse.subscribe((converseList:IAConversation[])=> { 
            const conv = converseList.find(d => d.sessionId === this.sessionId && d.agent === this.agent);
            if ( conv == null ){
                this.initLoading = true;
                this.iaService.loadAgentConfiguration(this.agent).then(wm=>{
                    this.iaService.updateConverse(this.sessionId, this.agent,
                    { text: (wm as string), role: 'assistant' });

                }).catch(error=>{
                    this.initLoading = false;
                    
                    GlobalErrorHandler.showError(error);
                }) .finally(()=>{ 
                    this.initLoading = false;
                });
            }
        });
    }

    scrollToBottom(): void {
        const scrollContainer = document.querySelector('.ia-response');
        if (scrollContainer) {
            scrollContainer.scrollTo({ top: scrollContainer.scrollHeight, behavior: 'smooth' });
        } else {
        // Se não há container de rolagem, rola para o final do canvas
        const canvas = document.querySelector('.ia-response');
        if (canvas) {
            canvas.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
    }
  }

   converseWithAI(prompt) {
        
        this.messages.subscribe(messages => {
            const firstQuestion = !messages || messages.length === 1;
            prompt = this.mountPrompt(prompt, firstQuestion)
        });

        this.iaService.updateConverse( this.sessionId, this.agent, { text: this.userPrompt, role: 'user' });

        this.iaService.sendPromptToAi(this.sessionId, this.agent, prompt, [], []).then((response:Answer) => {
                    
                    let responseTreat = this.reponseTratamento(response.answer, response.converseId);
                    let text = responseTreat.cleaned;
                    let jsonContent = responseTreat.json;

                    this.iaService.updateConverse(this.sessionId, this.agent,
                        { text: text, role: 'assistant', chunkId: response.citations, converseId: response.converseId, action: jsonContent });

                    
                    this.loading = false;
                    this.cd.detectChanges();
                    this.scrollToBottom();
            }).catch(error=>{
                    this.loading = false;
                    GlobalErrorHandler.showError(error);
            }).finally(()=>{
                this.cd.detectChanges();
            });
   }


   reponseTratamento(answer:string, converseId:string):{json:string|null, cleaned:string} {
    
        const startTag2 = '```json'
        const endTag2 = '```';
        

        const start = answer.indexOf(startTag2);
        const end = answer.indexOf(endTag2, start + startTag2.length);

        if (start === -1 || end === -1) {
            return { json: null, cleaned: answer };
        }
        
        const json = answer.slice(start + startTag2.length, end).trim();
        const linkHtml = `<span class='alterar-fluxo' id='${converseId}'>${this.ts.instant('ia.change.flow')}</span>`;
        const divider = `<span> | </span>`;
        const linkHtml2 = `<span class='consultar-fluxo' id='${converseId}'>${this.ts.instant('ia.view.flow')}</span>`;

        const cleaned = (answer.slice(0, start) + linkHtml + divider + linkHtml2 + answer.slice(end + endTag2.length)).trim();

        
        return { json, cleaned };
   }

   @HostListener('click', ['$event'])
    handleClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        if (target.classList.contains('alterar-fluxo')) {
            let converseId = target.getAttribute('id');
            this.onAlterarFluxo(converseId);
        }else if (target.classList.contains('consultar-fluxo')){
            let converseId = target.getAttribute('id');
            this.showTooltip(target, converseId);
        }
    }

    // @HostListener('document:keydown', ['$event'])
    // handleKeyDown(event: KeyboardEvent) {
    //     if (event.key === 'Ctrl' || event.key === 'Control') {
    //         this.isCtrlPressed = true;
    //     }
    // }

    // @HostListener('document:keyup', ['$event'])
    // handleKeyUp(event: KeyboardEvent) {
    //     if (event.key === 'Ctrl' || event.key === 'Control') {
    //         this.isCtrlPressed = false;
    //     }
    // }

    // @HostListener('mouseover', ['$event'])
    // handleMouseOver(event: MouseEvent) {
    //     const target = event.target as HTMLElement;
        
    //     if (target.classList.contains('alterar-fluxo') && this.isCtrlPressed) {
    //         let converseId = target.getAttribute('id');
    //         this.showTooltip(target, converseId);
    //     }
    // }

    getActionConversionId(converseId:string){
        let actionId:string = null; 

        return new Promise<string>((resolve) => {
            this.sub1 = this.converse.pipe(first()).subscribe((converseList:IAConversation[])=> {
                const conv = converseList.find(d => d.sessionId === this.sessionId && d.agent === this.agent);  
                if ( conv != null ){
                    const message = conv.messages.find(m=>m.converseId == converseId);
                    if ( message != null && message.action != null ){
                        actionId = message.action;
                        resolve(actionId);
                    }  
                }
            });
        });

        
    }

    async showTooltip(element: HTMLElement, converseId?:string) {

        let json  = await this.getActionConversionId(converseId).then(d=>d);
        
        this.modalService.info(
            {
                nzTitle: this.ts.instant('ia.change.flow.tooltip.title'),
                nzContent: IAJsonViewerModalComponent,
                nzData:json,
                nzOkText: this.ts.instant('close'),
                nzWidth: "70%",
                nzMaskClosable: true,
                nzCentered: true
            }
        )
    }
    

    async onAlterarFluxo(converseId:string) {
        if ( converseId == null ){
            this.drawerRef.close();
        }else{
            let action = await this.getActionConversionId(converseId).then(d=>d);
            this.drawerRef.close(action);
        }
    }


    mountPrompt(prompt: any, firstQuestion: boolean): any {
        let newPrompt = '';

        if ( firstQuestion ){
            newPrompt += 'Oi, meu nome é ' + this.uas.user.username + '. Preciso de assitência para criar fluxos. \n';
            newPrompt += 'Aqui está o meu primeiro prompt: ' + prompt;
        }else{
            newPrompt += prompt;
        }

        if ( this.flow != null ){
            if ( this.flow != null){
                newPrompt += '\nAqui está a estrutura do meu fluxo atual: ' + JSON.stringify(this.flow);
            }
            
            newPrompt += '\nBaseado nesta estrutura, responda às minhas perguntas.';
            newPrompt += '\nSe eu pedir para adicionar ou modificar algo, responda mudanças necessárias, devolvendo o fluxo completo e respeitando a estrutura do Objeto que é Array de steps e Array de connectors.\n';
        }

        if ( this.version != null && this.idconf != null ){
            newPrompt += '\nEstou usando a versão ' + this.version.sequence + ' do meu fluxo de IDCONF é  '+ this.idconf+' da tabela MKTPCFG. Considere isso ao responder.\n';
        }

        
        return newPrompt;
    }

}